module.exports = __webpack_public_path__ + "images/embed/icons/add_bullet.gif";